import { Link, Navigate, useNavigate } from "react-router-dom";
import "../sale/sale.css";

import { DeleteOutlined, DollarOutlined, EditOutlined, SearchOutlined, CloudDownloadOutlined, RedoOutlined } from "@ant-design/icons";
import { Button, Card, DatePicker, Form, Popover, Select, Input } from "antd";
import { Tooltip } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import axios from "axios";
import _ from "lodash";
import { useDebounce } from 'use-debounce';

import ViewBtn from "../Buttons/ViewBtn";
import DashboardCard from "../Card/DashboardCard";
import CreateDrawer from "../CommonUi/CreateDrawer";
import StatusSelection from "../CommonUi/StatusSelection";
import TableComponent from "../CommonUi/TableComponent";
import SaleReportPrint from "../Invoice/SaleReport";
import UserPrivateComponent from "../PrivacyComponent/UserPrivateComponent";
import { PERMISSIONS } from "../../utils/constants";
import { getCustomerSetting } from "../../api/getSettings";

import { deleteSale, getAllSale, loadAllSale, getAllSaleProducts } from "../../redux/rtk/features/nonGstSale/nonGstSaleSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import AddNonGstSale from "./addNonGstSale";

const GetAllNonGstSale = (props) => {

  const dispatch = useDispatch();
  const {
    list,
    total,
    loading: saleLoading,
    totalList,
    allSaleProductsLoading,
    allSaleProducts,
  } = useSelector((state) => state.nonGstSales);
  const [invoiceReportLoader, setInvoiceReportLoader] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText] = useDebounce(searchText, 300);

  const {
    grandTotal = 0,
    profit = 0,
    dueAmount = 0,
    paidAmount = 0
  } = total?._sum || {}


  const userList = useSelector((state) => state.users.list);
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  const [startdate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [enddate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(true);

  //Delete Customer
  const onDelete = (id) => {
    const deleteSuccessCallBack = () => {
      loadSales();
      toast.warning(`Sale : ${id} is removed `);
      return navigate("/admin/branch-sale");
    }
    try {
      dispatch(deleteSale({ id, deleteSuccessCallBack }));
    } catch (error) {
      console.log(error.message);
    }
  };

  const invoiceData = useSelector((state) => state.accounts.appSettings);

  const [customerSettings, setCustomerSettings] = useState({});
  useEffect(() => {
    getCustomerSetting().then((data) => setCustomerSettings(data?.result));
  }, []);

  const handleRestore = (data) => {
    navigate("/admin/branch-sale/add", { state: { data } });
  }

  const columns = [
    {
      id: 1,
      title: "No",
      dataIndex: "manualId",
      key: "manualId",
      render: (name, { id, manualId }) => <Link to={`/admin/branch-sale/${id}`}>{manualId}</Link>,
      width: 0.7 * 100,
    },
    {
      id: 2,
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => moment(date).format("DD/MM/YYYY"),
      width: 1.1 * 100,
    },
    {
      id: 3,
      title: "Name ",
      dataIndex: `customer`,
      key: "customerId",
      render: (customer) => customer?.name,
      width: 1.7 * 100,
    },

    customerSettings?.showReferredBy ? {
      id: 4,
      title: "Ref By",
      dataIndex: `customer`,
      key: "customerId",
      render: (customer) => customer?.referBy,
      width: 1 * 100,
    } : null,

    customerSettings?.showAge ? {
      id: 5,
      title: "Age",
      dataIndex: `customer`,
      key: "customerId",
      render: (customer) => customer?.age,
      width: 0.6 * 100,
    } : null,

    invoiceData?.show_table_number ? {
      id: 9,
      title: "Table No",
      dataIndex: "tableNo",
      key: "tableNo",
      width: 1 * 100,
    } : null,
    // {
    //   id: 4,
    //   title: "Total MRP",
    //   dataIndex: "totalMRP",
    //   key: "totalMRP",
    //   responsive: ["md"],
    // },
    // {
    //   id: 5,
    //   title: "Discount",
    //   dataIndex: "id",
    //   key: "discount",
    //   render: (id, { discount, discount_type }) => <>{discount_type == "amount" ? "₹" : " "}{discount}{discount_type == "percentage" ? "%" : " "} </>,
    // },
    {
      id: 6,
      title: "Total",
      dataIndex: "totalAmount",
      key: "totalAmount",
      width: 1 * 100,
    },
    {
      id: 7,
      title: "Discount",
      dataIndex: "discountedAmount",
      key: "discountedAmount",
      width: 0.9 * 100,
    },
    {
      id: 8,
      title: "G.Total",
      dataIndex: "grandTotal",
      key: "grandTotal",
      width: 1 * 100,
    },
    {
      id: 10,
      title: "Qty",
      dataIndex: "productQty",
      key: "productQty",
      width: 0.7 * 100,
    },
    {
      id: 11,
      title: "Due",
      dataIndex: "dueAmount",
      key: "dueAmount",
      width: 1 * 100,
    },
    {
      id: 12,
      title: "Paid",
      dataIndex: "paidAmount",
      key: "paidAmount",
      width: 1 * 100,
      render: (data, saleInvoice) => _.filter(saleInvoice.modeOfPayments, "amount").length > 1 ? _.reduce(saleInvoice.modeOfPayments, (sum, each) => sum + each.amount, 0) : data
    },
    {
      id: 13,
      title: "Mode",
      dataIndex: "modeOfPayments",
      key: "modeOfPayments",
      width: 1 * 100,
      render: (data, saleInvoice) => _.filter(data, "amount").length > 1 ? _.join(_.map(data, (each) => each.modeOfPayment), ", ") : saleInvoice.modeOfPayment
    },

    //Update Supplier Name here

    // {
    //   id: 14,
    //   title: "Profit",
    //   dataIndex: "profit",
    //   key: "profit",
    //   render: (profit) => Number(profit).toFixed(2),
    // },
    // {
    //   id: 15,
    //   title: "Sale Person",
    //   dataIndex: "user",
    //   key: "user",
    //   render: (user) => user?.username,
    // },
    {
      id: 16,
      title: "Action",
      dataIndex: "id",
      key: "payment",
      render: (id, data) => {
        return (
          <div className='flex '>
            {status ?
              <>
                <ViewBtn path={`/admin/branch-sale/${id}`} />
                <Link
                  className='mr-2 d-inline-block'
                  to={`/admin/branch-sale/${id}/update`}
                  state={{ data }}
                ><Tooltip title="Edit">
                    <Button
                      type='primary'
                      className="flex justify-center w-[38px] h-[30px] items-center bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded"
                      shape='round'
                      icon={<EditOutlined />}
                    ></Button></Tooltip>
                </Link>
                <Popover
                  className="mr-2"
                  content={
                    <a onClick={() => onDelete(id)}>
                      <Button type='primary' danger>
                        Yes Please !
                      </Button>
                    </a>
                  }
                  placement="topLeft"
                  title='Are you sure you want to delete ?'
                  trigger='click'
                ><Tooltip title="Delete">
                    <Button
                      className="flex justify-center w-[38px] bg-red-500 hover:bg-red-700 h-[30px] items-center text-white font-bold py-2 px-3 rounded"
                      shape='round'
                      icon={<DeleteOutlined />}
                    ></Button>
                  </Tooltip>
                </Popover>
                <Link
                  to={data.dueAmount ? `/admin/payment/customer/${id}` : "#"}
                  state={{ dueAmount: data.dueAmount || 0, isNonGstSaleInvoice: true }}
                ><Tooltip title="Payment">
                    <Button
                      className="flex justify-center w-[38px] h-[30px] items-center bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-3 rounded mr-2"
                      shape='round'
                      icon={<DollarOutlined />}
                    ></Button></Tooltip>
                </Link>
              </>
              : <Button
                className="flex justify-center w-[38px] h-[30px] items-center bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded"
                shape='round'
                title="Restore"
                onClick={() => handleRestore(data)}
                icon={<RedoOutlined />}
              ></Button>
            }
          </div>
        )
      },
    },
  ];
  const filteredColumns = columns.filter(column => column !== null);

  useEffect(() => {
    dispatch(loadAllStaff({ status: true }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllSale({})); // to load all sale details for download csv
  }, []);

  useEffect(() => {
    dispatch(
      loadAllSale({
        page: 1,
        count: 10,
        status: true,
        startdate: startdate,
        enddate: enddate,
        user: "",
        type: "INVOICE",
        searchText: debouncedSearchText
      })
    );
  }, [debouncedSearchText]);

  const handleInputChange = (e) => {
    setSearchText(e.target.value);
  };

  const { RangePicker } = DatePicker;

  const loadSales = () => {
    dispatch(
      loadAllSale({
        page: 1,
        count: 10,
        status: true,
        startdate: startdate,
        enddate: enddate,
        user: "",
        type: "INVOICE"
      })
    );
  }

  const getInvoiceProducts = () => {
    dispatch(
      getAllSaleProducts({
        startdate: startdate,
        enddate: enddate,
      })
    );
  };

  useEffect(() => {
    loadSales();
    getInvoiceProducts()
  }, [dispatch, enddate, startdate]);

  const onSearchFinish = async (values) => {
    setUser(values?.user);
    const resp = await dispatch(
      loadAllSale({
        page: 1,
        count: "",
        status: true,
        startdate: startdate,
        enddate: enddate,
        user: values.user ? values.user : "",
      })
    );
    if (resp.payload.message === "success") {
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  const [form] = Form.useForm();

  const onCalendarChange = (dates) => {
    const startdate = (dates?.[0]).format("YYYY-MM-DD");
    const enddate = (dates?.[1]).format("YYYY-MM-DD");
    setStartDate(startdate);
    setEndDate(enddate);
  };

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Products");

    // Define headers
    worksheet.columns = [
      { header: "S No", key: "index", width: 10 },
      { header: "SKU", key: "sku", width: 10 },
      { header: "Product Name", key: "name", width: 20 },
      {
        header: "Sold Qty",
        key: "productQty",
        width: 15,
      },
      {
        header: "Available Qty",
        key: "availableQty",
        width: 15,
        border: true,
      },
    ];
    // Set header row style
    worksheet.getRow(1).font = { bold: true };

    // Add data
    allSaleProducts.forEach((item, index) => {
      worksheet.addRow({
        ...item,
        index: index + 1,
      });
    });
    //Add style for the column
    worksheet.columns.forEach((column) => {
      column.alignment = { horizontal: "left" };
    });

    // Save Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "sale product report.xlsx");
  };

  const exportInvoiceReport = async () => {
    try {
      setInvoiceReportLoader(true);
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        responseType: 'arraybuffer', // Set the responseType to 'arraybuffer' to receive data as a buffer
        url: `non-gst-sale-invoice/generate-report`,
        data: {
          startdate: startdate,
          enddate: enddate,
        },
      });

      // Create a Blob from the received buffer
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a URL for the Blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = 'invoice_report.xlsx'; // Specify the filename for the downloaded file

      // Append the anchor to the body and trigger a click event to start the download
      document.body.appendChild(a);
      a.click();

      // Clean up: remove the anchor and revoke the URL to release memory
      window.URL.revokeObjectURL(url);
      a.remove();

      toast.success("Report downloaded successful!");

    } catch (error) {
      setInvoiceReportLoader(false);
      toast.warn("Issue while Report downloaded!");
      console.error("Error exporting invoice report:", error);
      // Handle errors
    } finally {
      setInvoiceReportLoader(false);
    }
  }

  return (
    <>
      <div className='card card-custom mt-2'>
        <div className='card-body '>
          <div className='card-title flex  md:flex-row center justify-content-md-center mt-1 py-2'>
            <div>
              <Form
                onFinish={onSearchFinish}
                form={form}
                layout={"inline"}
                onFinishFailed={() => setLoading(false)}
                className=""
              >
                <Form.Item name='user' className="max-sm:pb-2">
                  <Select
                    className='salelist-saleperson-input w-[200px]'
                    loading={!userList}
                    placeholder='Sale Person'
                    allowClear
                  >
                    <Select.Option value=''>All</Select.Option>
                    {userList &&
                      userList.map((i) => (
                        <Select.Option value={i.id}>{i.username}</Select.Option>
                      ))}
                  </Select>
                </Form.Item>
                <div className=' mr-2 lg:mr-4'>
                  <RangePicker
                    onCalendarChange={onCalendarChange}
                    defaultValue={[
                      dayjs(startdate, "YYYY-MM-DD"),
                      dayjs(enddate, "YYYY-MM-DD"),
                    ]}
                    className='range-picker'
                  />
                </div>

                <Form.Item>
                  <Button
                    onClick={() => setLoading(true)}
                    loading={loading}
                    type='primary'
                    htmlType='submit'
                    className='salelist-search-btn btnHeight'
                  >
                    <SearchOutlined />
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
          <UserPrivateComponent permission={PERMISSIONS.READALL_SALE_DASHBOARD}>
            <DashboardCard
              information={total?._sum ? Number(total?._sum).toFixed(3) : 0}
              count={total?._count}
              profit={profit}
              dueAmount={dueAmount}
              paidAmount={paidAmount}
              grandTotal={grandTotal}
              isCustomer={true}
            />
          </UserPrivateComponent>
          <br />

          <Card className='border-0 md:border md:p-6 bg-transparent md:bg-[#fafafa] dark:bg-[#2a2931]' bodyStyle={{ padding: 0 }}>
            <div className="lg:flex gap-1 gap-2 justify-center items-center ">
              <div className="flex max-sm:mb-3">
                <h1 className='text-lg font-bold w-24'>Sale list</h1>
                <Input className="w-80 lg:w-96" placeholder='Search Sale' value={searchText} onChange={handleInputChange} />
              </div>
              <div className=' min-lg:w-1/2  max-lg:flex-col lg:flex-row  flex  gap-1 max-sm:grid max-sm:grid-cols-2'>
                <StatusSelection
                  paginatedThunk={loadAllSale}
                  query={{ user, startdate, enddate }}
                  setStatusChangeFlag={setStatus}
                />
                <Button
                  className="xs:px-3 px-1 text-sm md:text-base py-1 lg:px-3  border bg-teal-700 hover:bg-teal-500 text-white rounded cursor-pointer"
                  icon={<CloudDownloadOutlined />}
                  shape="round"
                  loading={allSaleProductsLoading}
                  onClick={exportToExcel}
                >
                  Product
                </Button>
                <Button
                  className="xs:px-3 px-1 text-sm md:text-base py-1 lg:px-3  border bg-teal-700 hover:bg-teal-500 text-white rounded cursor-pointer"
                  icon={<CloudDownloadOutlined />}
                  shape="round"
                  loading={invoiceReportLoader}
                  onClick={exportInvoiceReport}
                >
                  Payment
                </Button>
                <SaleReportPrint
                  data={list}
                  // data={totalList}
                  date={{ startdate, enddate }}
                  user={user}
                  total={total?._sum}
                />
                <CreateDrawer
                  permission={"create-saleInvoice"}
                  title={"Add Sale"}
                  width={92}
                  className="max-sm:col-span-2"
                >
                  <AddNonGstSale />
                </CreateDrawer>
              </div>
            </div>
            <UserPrivateComponent permission={"readAll-saleInvoice"}>
              <TableComponent
                className="overflow-x-auto"
                list={list}
                allList={totalList}
                columns={filteredColumns}
                loading={saleLoading}
                total={total?._count?.id}
                paginatedThunk={loadAllSale}
                csvFileName={"all branch sale"}
                scrollx={1350}
                query={{ startdate, enddate }}
                showDraftBtn={true}
                draftUrl={"/admin/branch-sale/draft"}
              />
            </UserPrivateComponent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default GetAllNonGstSale;
